import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import styled, { keyframes } from 'styled-components'
import AnimationContainer from 'components/animation-container'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faArrowLeft, faArrowRight,   
} from '@fortawesome/free-solid-svg-icons'
import { Link } from 'gatsby'


class BotonApp extends React.Component {

    shouldComponentUpdate() {
        return false
    }

    constructor(props) {
        super(props)
        this.state = {
            height: 0,
            width: 0
        }
    }

    updateDimensions = () => {
        if (this.state.height !== window.innerHeight) {
            this.setState({height: window.innerHeight})
        }
        if (this.state.width !== window.innerWidth) {
            this.setState({width: window.innerWidth})
        }
    }

    
    componentDidMount() {
        this.setState({height: window.innerHeight, width: window.innerWidth})
        window.addEventListener('resize', this.updateDimensions)
    }
    
    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions)
    }
      
    render() {

        const Section = styled.section`
            position: relative;
            overflow: hidden;
            background-color: #f6f6f6;
            padding: 100px 0 50px 0;
            .heading {
                width: 100%;
            }
            @media (max-width: 767px) {
                padding: 50px 0 50px 0;           
            }
            @media (min-width:768px) and (max-width:1500px) {
                padding: 50px 0 50px 0;              
            }
        `

        const ServiceRow = styled(Row)`
            flex-wrap: wrap;
            margin-right: -15px;
            margin-left: -15px;
            display: flex;
        `

        const ServiceHeading = styled.h3`
            font-size: 18px;
            font-weight: 700;
            color: #212122;
            @media (max-width: 767px) {
              font-size: 16px;
          }
        `

        const Heading = styled.h2`
            font-size: 24px;
            font-weight: 700;
            color: #212122;
            text-align:center;
        `

        const ServiceHeadinga = styled(Link)`
            color: #000;         
            &:before {
              content: '';
              position: absolute;
              top: 35px;
              bottom: 0;
              left: 28%;
              width: 1px;
              height: 50%;
              background: #ebebeb;
              transition: all .3s ease;
            }
            &:hover {
              color: #65ff00;              
            }
        `
         
        const ServiceText = styled.p`
            font-size: 16px;
            line-height: 26px;
            color: #808080;
            margin-top: 5px;
            font-family: 'Open Sans',sans-serif;
            font-weight: normal;
            @media (max-width: 767px) {
              font-size: 14px;
              line-height: 20px;
          }
        `

        const Inform = styled.div`
            width: 72%;
            padding: 10px 30px;
            display: inline-block;
            vertical-align: middle;
        `

        const ServiceWrap = styled.div`            
            font-weight: bold;
            color: #ff6d37;            
        `

        const AnimatedShadow = keyframes`
            0%   {box-shadow: 0 2px 60px rgba(126, 126, 126, .5);}
            10%  {box-shadow: 0 4px 60px rgba(80,115,184, .5);}
            20%  {box-shadow: 0 6px 60px rgba(80,115,184, .5);}
            30%  {box-shadow: 0 10px 60px rgba(126, 126, 126, .5);}
            40% {box-shadow: 0 14px 60px rgba(80, 115, 184, .5);}
            50% {box-shadow: 0 16px 60px rgba(126, 126, 126, .5);}
            60% {box-shadow: 0 18px 60px rgba(62, 62, 62, .5);}
            70% {box-shadow: 0 22px 60px rgba(62, 62, 62, .5);}
            80% {box-shadow: 0 24px 60px rgba(80, 115, 184, .5);}
            90% {box-shadow: 0 26px 60px rgba(16, 152, 173, .5);}
            100% {box-shadow: 0 28px 60px rgba(126, 126, 126, .5);}
            -webkit-transition: all 300ms linear 0ms;
	          -moz-transition: all 300ms linear 0ms;
	          -ms-transition: all 300ms linear 0ms;
	          transition: all 300ms linear 0ms;
            transition: all .3s ease;
        `

        const HelpContainer = styled.div`            
            position: relative;
            height: 145px;
            margin-top: 50px;
            border-radius: 3px;
            background-color: #fff;
            box-shadow: 0 5px 15px 0 rgba(110, 110, 110, .1);
            transition: all .3s ease;
            &:hover {
              background-color: #fff;
              animation: ${AnimatedShadow} 10s infinite alternate;
              transform: translateY(-5px);
              
          }
        `

        const Img = styled.div`            
            display: inline-block;
            vertical-align: middle;
            position: relative;
            width: 28%;
            height: 100%;
        `

        const Ico = styled.svg`            
            position: absolute;
            top: 30%;
            left: 30%
        `

        const BadgeGrey = styled.div`
            position: absolute;
            right: auto;
            left: 10px !important;
            display: inline-block;
            padding: .25em .4em;
            background-color: #808080 !important;
            color: #ffffff !important;
            top: 10px;
            z-index: 1;
            font-size: 75%;
            font-weight: 700;
            line-height: 1;
            text-align: center;
            white-space: nowrap;
            vertical-align: baseline;
            border-radius: .10rem;
            transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
        `

        const BadgeGreyR = styled.div`
            position: absolute;
            right: 10px;            
            display: inline-block;
            padding: .25em .4em;
            background-color: #808080 !important;
            color: #ffffff !important;
            top: 10px;
            z-index: 1;
            font-size: 75%;
            font-weight: 700;
            line-height: 1;
            text-align: center;
            white-space: nowrap;
            vertical-align: baseline;
            border-radius: .10rem;
            transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
        `

        return(
          <Section>
            <Container>
              <Col md={12}>
                <Heading>
                  ¿Necesitas un diseño web personalizado o un software a la medida?
                </Heading>
              </Col>
              <ServiceWrap>
                <ServiceRow>
                  <Col md={6}>
                    <AnimationContainer animation="fadeInDown" delay={200}>
                      <HelpContainer>
                        <BadgeGrey><FontAwesomeIcon icon={faArrowLeft} size="1x" /></BadgeGrey>
                        <Img>
                          <Ico>
                            <svg fill="none" height="64" width="64" xmlns="http://www.w3.org/2000/svg" viewBox="670.088 32.46226489559854 2224.1720000000005 2666.4877351044024"><g fill="#61dafb"><path d="M2870 1250.22c0-145.34-182.01-283.079-461.07-368.495 64.4-284.424 35.78-510.711-90.34-583.159-29.07-16.994-63.05-25.044-100.17-25.044v99.728c20.57 0 37.12 4.025 50.98 11.627 60.82 34.882 87.21 167.703 66.63 338.536-4.91 42.038-12.96 86.311-22.8 131.479-87.66-21.466-183.36-38.012-283.98-48.745-60.37-82.734-122.98-157.865-186.04-223.604 145.79-135.504 282.64-209.741 375.66-209.741v-99.727c-122.99 0-283.98 87.653-446.76 239.703-162.79-151.156-323.78-237.914-446.76-237.914v99.727c92.57 0 229.86 73.79 375.65 208.399-62.61 65.74-125.22 140.423-184.7 223.157-101.07 10.733-196.77 27.279-284.42 49.192-10.29-44.72-17.89-88.1-23.26-129.69-21.01-170.833 4.92-303.654 65.3-338.983 13.41-8.05 30.85-11.627 51.43-11.627v-99.728c-37.57 0-71.56 8.05-101.07 25.044-125.67 72.447-153.84 298.287-89 581.817C857.119 968.036 676 1105.33 676 1250.22c0 145.35 182.013 283.09 461.07 368.5-64.4 284.43-35.78 510.71 90.34 583.16 29.07 16.99 63.05 25.04 100.62 25.04 122.98 0 283.98-87.65 446.76-239.7 162.78 151.16 323.78 237.92 446.76 237.92 37.56 0 71.55-8.05 101.07-25.05 125.66-72.45 153.84-298.29 88.99-581.81 277.27-85.42 458.39-223.16 458.39-368.06zm-582.26-298.284c-16.55 57.694-37.12 117.164-60.38 176.644-18.33-35.77-37.56-71.55-58.58-107.33-20.57-35.773-42.49-70.655-64.4-104.643 63.5 9.391 124.77 21.019 183.36 35.329zm-204.83 476.274c-34.88 60.38-70.65 117.62-107.77 170.84-66.64 5.81-134.16 8.94-202.14 8.94-67.53 0-135.06-3.13-201.24-8.5-37.12-53.22-73.35-110.01-108.23-169.94-33.99-58.58-64.84-118.06-93.02-177.98 27.73-59.93 59.03-119.86 92.58-178.44 34.88-60.37 70.65-117.616 107.77-170.834 66.64-5.814 134.16-8.944 202.14-8.944 67.53 0 135.06 3.13 201.24 8.497 37.12 53.218 73.35 110.011 108.23 169.941 33.99 58.58 64.84 118.06 93.02 177.99-28.18 59.92-59.03 119.85-92.58 178.43zm144.45-58.13a1918.154 1918.154 0 0 1 61.72 177.98c-58.59 14.31-120.3 26.39-184.25 35.78 21.91-34.43 43.82-69.76 64.4-105.99 20.57-35.77 39.8-72 58.13-107.77zm-453.47 477.17c-41.59-42.94-83.18-90.79-124.32-143.11 40.25 1.79 81.39 3.13 122.98 3.13 42.04 0 83.63-.89 124.33-3.13a1746.499 1746.499 0 0 1-122.99 143.11zm-332.72-263.41c-63.5-9.39-124.77-21.02-183.35-35.33 16.54-57.69 37.12-117.17 60.37-176.65 18.34 35.78 37.57 71.56 58.58 107.33 21.02 35.78 42.49 70.66 64.4 104.65zm330.49-930.638c41.59 42.931 83.18 90.783 124.32 143.106-40.25-1.789-81.39-3.13-122.98-3.13-42.04 0-83.63.894-124.32 3.13a1746.3 1746.3 0 0 1 122.98-143.106zm-330.94 263.405c-21.91 34.435-43.82 69.764-64.39 105.983-20.57 35.78-39.8 71.56-58.14 107.33a1914.757 1914.757 0 0 1-61.71-177.984c58.58-13.863 120.29-25.938 184.24-35.329zM1036 1476.51c-158.309-67.53-260.72-156.07-260.72-226.29 0-70.21 102.411-159.2 260.72-226.28 38.46-16.55 80.5-31.308 123.88-45.171 25.49 87.651 59.03 178.881 100.62 272.351-41.14 93.02-74.24 183.8-99.28 271.01-44.27-13.87-86.31-29.07-125.22-45.62zm240.6 639.06c-60.82-34.88-87.21-167.7-66.63-338.54 4.92-42.03 12.96-86.31 22.8-131.48 87.66 21.47 183.36 38.02 283.98 48.75 60.37 82.73 122.98 157.86 186.04 223.6-145.79 135.51-282.64 209.74-375.66 209.74-20.12-.44-37.11-4.47-50.53-12.07zm1060.78-340.77c21.01 170.83-4.92 303.65-65.3 338.98-13.41 8.05-30.85 11.63-51.43 11.63-92.57 0-229.86-73.79-375.65-208.4 62.61-65.74 125.22-140.42 184.7-223.16 101.07-10.73 196.77-27.28 284.42-49.19 10.29 45.17 18.34 88.55 23.26 130.14zm172.17-298.29c-38.46 16.55-80.5 31.31-123.88 45.17-25.49-87.65-59.03-178.88-100.62-272.35 41.15-93.02 74.24-183.8 99.28-271.009 44.28 13.864 86.31 29.069 125.67 45.619 158.31 67.52 260.72 156.07 260.72 226.28-.45 70.22-102.86 159.21-261.17 226.29z" /><path d="M1772.55 1454.6c112.88 0 204.38-91.5 204.38-204.38 0-112.87-91.5-204.37-204.38-204.37-112.87 0-204.37 91.5-204.37 204.37 0 112.88 91.5 204.38 204.37 204.38zM775.625 2578.81H708.16V2695h-38.072v-287.22h95.082c32.351 0 57.207 7.37 74.566 22.1 17.491 14.72 26.237 36.16 26.237 64.3 0 17.89-4.866 33.47-14.598 46.76-9.6 13.28-23.014 23.21-40.242 29.78l67.465 121.91v2.37h-40.637zm-67.465-30.97h58.194c18.806 0 33.732-4.87 44.779-14.6 11.178-9.73 16.767-22.75 16.767-39.06 0-17.75-5.326-31.36-15.978-40.83-10.521-9.47-25.776-14.27-45.766-14.4H708.16zm293.93 151.11c-28.936 0-52.477-9.47-70.625-28.41-18.149-19.07-27.223-44.52-27.223-76.34v-6.71c0-21.17 4.011-40.04 12.033-56.61 8.154-16.71 19.464-29.73 33.93-39.06 14.598-9.47 30.379-14.21 47.344-14.21 27.751 0 49.321 9.14 64.701 27.42 15.39 18.28 23.08 44.45 23.08 78.51v15.19H940.736c.526 21.05 6.642 38.08 18.346 51.1 11.836 12.88 26.828 19.33 44.978 19.33 12.89 0 23.8-2.63 32.74-7.89 8.95-5.26 16.77-12.23 23.48-20.91l22.29 17.36c-17.89 27.48-44.71 41.23-80.48 41.23zm-4.541-191.35c-14.729 0-27.091 5.39-37.086 16.17-9.995 10.66-16.176 25.65-18.543 44.98h106.92v-2.76c-1.05-18.54-6.05-32.88-14.99-43.01-8.95-10.25-21.05-15.38-36.301-15.38zM1259.52 2695c-2.11-4.21-3.82-11.7-5.13-22.49-16.97 17.62-37.22 26.44-60.76 26.44-21.04 0-38.33-5.92-51.88-17.76-13.41-11.97-20.12-27.09-20.12-45.37 0-22.22 8.42-39.45 25.25-51.68 16.96-12.37 40.77-18.55 71.41-18.55h35.51v-16.76c0-12.76-3.82-22.89-11.44-30.38-7.63-7.63-18.88-11.44-33.74-11.44-13.02 0-23.93 3.28-32.74 9.86-8.81 6.57-13.22 14.53-13.22 23.87h-36.69c0-10.65 3.75-20.91 11.24-30.78 7.63-9.99 17.89-17.88 30.78-23.67 13.02-5.78 27.28-8.68 42.8-8.68 24.6 0 43.86 6.18 57.8 18.55 13.94 12.23 21.17 29.13 21.7 50.69v98.24c0 19.6 2.5 35.18 7.5 46.75v3.16zm-60.56-27.81c11.44 0 22.29-2.96 32.55-8.88 10.25-5.92 17.68-13.61 22.29-23.08v-43.79h-28.61c-44.71 0-67.07 13.08-67.07 39.25 0 11.44 3.82 20.39 11.44 26.83 7.63 6.44 17.43 9.67 29.4 9.67zm234.15 1.97c13.02 0 24.4-3.95 34.13-11.84s15.12-17.75 16.17-29.59h34.53c-.66 12.23-4.87 23.87-12.63 34.92s-18.15 19.86-31.17 26.43c-12.89 6.58-26.56 9.87-41.03 9.87-29.06 0-52.21-9.67-69.44-29-17.09-19.47-25.64-46.03-25.64-79.7v-6.11c0-20.78 3.81-39.26 11.44-55.43 7.63-16.18 18.54-28.74 32.75-37.68 14.33-8.95 31.23-13.42 50.69-13.42 23.94 0 43.8 7.17 59.58 21.51 15.91 14.33 24.39 32.94 25.45 55.82h-34.53c-1.05-13.81-6.31-25.12-15.78-33.93-9.33-8.94-20.91-13.41-34.72-13.41-18.54 0-32.94 6.7-43.2 20.12-10.12 13.28-15.19 32.55-15.19 57.8v6.9c0 24.59 5.07 43.53 15.19 56.81 10.13 13.29 24.6 19.93 43.4 19.93zm175.37-239.28v51.68h39.85v28.21h-39.85v132.36c0 8.55 1.78 14.99 5.33 19.33 3.55 4.21 9.6 6.32 18.15 6.32 4.2 0 9.99-.79 17.35-2.37V2695c-9.6 2.63-18.93 3.95-28.01 3.95-16.3 0-28.6-4.94-36.89-14.8-8.28-9.86-12.42-23.87-12.42-42.02v-132.36h-38.87v-28.21h38.87v-51.68zM2017.81 2695h-38.08l-144.59-221.33V2695h-38.07v-287.22h38.07l144.99 222.32v-222.32h37.68zm193.32 0c-2.11-4.21-3.82-11.7-5.13-22.49-16.97 17.62-37.22 26.44-60.76 26.44-21.04 0-38.34-5.92-51.88-17.76-13.41-11.97-20.12-27.09-20.12-45.37 0-22.22 8.41-39.45 25.25-51.68 16.96-12.37 40.77-18.55 71.41-18.55h35.51v-16.76c0-12.76-3.82-22.89-11.45-30.38-7.62-7.63-18.87-11.44-33.73-11.44-13.02 0-23.93 3.28-32.74 9.86-8.81 6.57-13.22 14.53-13.22 23.87h-36.69c0-10.65 3.75-20.91 11.24-30.78 7.63-9.99 17.89-17.88 30.78-23.67 13.02-5.78 27.28-8.68 42.8-8.68 24.59 0 43.86 6.18 57.8 18.55 13.94 12.23 21.17 29.13 21.7 50.69v98.24c0 19.6 2.5 35.18 7.5 46.75v3.16zm-60.56-27.81c11.44 0 22.29-2.96 32.55-8.88 10.25-5.92 17.68-13.61 22.29-23.08v-43.79h-28.61c-44.71 0-67.07 13.08-67.07 39.25 0 11.44 3.82 20.39 11.44 26.83 7.63 6.44 17.43 9.67 29.4 9.67zm198.05-237.31v51.68h39.85v28.21h-39.85v132.36c0 8.55 1.78 14.99 5.33 19.33 3.55 4.21 9.6 6.32 18.15 6.32 4.2 0 9.99-.79 17.36-2.37V2695c-9.61 2.63-18.94 3.95-28.02 3.95-16.3 0-28.6-4.94-36.89-14.8-8.28-9.86-12.42-23.87-12.42-42.02v-132.36h-38.86v-28.21h38.86v-51.68zM2470.93 2695h-36.5v-213.44h36.5zm-39.46-270.06c0-5.91 1.78-10.91 5.33-14.99 3.68-4.08 9.07-6.11 16.17-6.11 7.11 0 12.5 2.03 16.18 6.11s5.52 9.08 5.52 14.99c0 5.92-1.84 10.85-5.52 14.8-3.68 3.94-9.07 5.92-16.18 5.92-7.1 0-12.49-1.98-16.17-5.92-3.55-3.95-5.33-8.88-5.33-14.8zm168.47 220.55l52.86-163.93h37.29L2613.55 2695h-27.82l-77.32-213.44h37.28zm211.07 53.46c-28.93 0-52.47-9.47-70.62-28.41-18.15-19.07-27.22-44.52-27.22-76.34v-6.71c0-21.17 4.01-40.04 12.03-56.61 8.15-16.71 19.46-29.73 33.93-39.06 14.6-9.47 30.38-14.21 47.34-14.21 27.75 0 49.32 9.14 64.71 27.42 15.38 18.28 23.08 44.45 23.08 78.51v15.19h-144.6c.53 21.05 6.64 38.08 18.35 51.1 11.83 12.88 26.83 19.33 44.97 19.33 12.89 0 23.81-2.63 32.75-7.89s16.77-12.23 23.48-20.91l22.29 17.36c-17.89 27.48-44.72 41.23-80.49 41.23zm-4.54-191.35c-14.72 0-27.09 5.39-37.08 16.17-10 10.66-16.18 25.65-18.54 44.98h106.91v-2.76c-1.05-18.54-6.05-32.88-14.99-43.01-8.94-10.25-21.04-15.38-36.3-15.38z" /></g></svg>
                          </Ico>
                        </Img>
                        <Inform>
                          <ServiceHeading>
                            <ServiceHeadinga to="/desarrollo-de-software">
                              Ver Desarrollo Web a la Medida
                            </ServiceHeadinga>
                          </ServiceHeading>
                          <ServiceText>Desarrollo Web o Software Web a la medida en la nube, según sus necesidades.</ServiceText>
                        </Inform>
                      </HelpContainer>
                    </AnimationContainer>
                  </Col>
                  <Col md={6}>
                    <AnimationContainer animation="fadeInDown" delay={200}>
                      <HelpContainer>
                        <BadgeGreyR><FontAwesomeIcon icon={faArrowRight} size="1x" /></BadgeGreyR>
                        <Img>
                          <Ico>
                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 32 32">
                              <title>wordpress</title>
                              <path id="svg-ico" fill="#464646" d="M10.412 27.931c-0.063 0-0.125-0.012-0.188-0.044-4.55-2.206-7.487-6.875-7.487-11.9 0-1.931 0.419-3.787 1.212-5.369 0.075-0.15 0.225-0.244 0.4-0.231 0.169 0.012 0.313 0.119 0.375 0.275l6.050 16.6c0.050 0.069 0.081 0.156 0.081 0.25 0 0.238-0.213 0.431-0.431 0.425-0.006-0.006-0.006-0.006-0.012-0.006zM4.294 11.95c-0.462 1.238-0.706 2.613-0.706 4.037 0 4.338 2.344 8.394 6.050 10.619l-5.344-14.656z"></path>
                              <path id="svg-ico" fill="#464646" d="M22.325 24.175c-0.188 0-0.35-0.119-0.406-0.3l-4.275-13.85c-0.038-0.131-0.019-0.269 0.063-0.375s0.206-0.169 0.337-0.169c0.725 0 1.337-0.119 1.344-0.119l0.225 0.394-0.125-0.406c0-0.006-0.012-0.063-0.050-0.131-0.031-0.050-0.069-0.056-0.1-0.056-0.056 0.006-2.075 0.131-3.369 0.131s-3.306-0.125-3.394-0.131c-0.113 0-0.131 0.063-0.144 0.081-0.019 0.050-0.006 0.094 0.006 0.106 0.025 0 0.088 0.006 0.119 0.012 0.006 0 0.619 0.119 1.213 0.119 0.181 0 0.338 0.113 0.4 0.281l1.944 5.438c0.031 0.094 0.031 0.2 0 0.294l-2.85 7.569c-0.063 0.169-0.213 0.281-0.4 0.275-0.175 0-0.338-0.113-0.394-0.281l-4.662-13.006c-0.044-0.131-0.025-0.275 0.050-0.387 0.081-0.113 0.206-0.181 0.344-0.181 0.719 0 1.338-0.119 1.344-0.119 0 0 0.088-0.006 0.106-0.012-0.012 0-0.012-0.069-0.050-0.131-0.031-0.050-0.069-0.056-0.1-0.056-0.056 0.006-2.075 0.131-3.362 0.131h-0.769c-0.156 0-0.3-0.088-0.375-0.219-0.075-0.137-0.069-0.3 0.019-0.431 2.375-3.638 6.575-5.894 10.969-5.894 3.275 0 6.35 1.181 8.887 3.413 0.131 0.069 0.225 0.213 0.225 0.375 0 0.231-0.188 0.425-0.425 0.425-0.006 0-0.012 0-0.019 0h-0.131c-1.063 0-1.775 0.987-1.775 1.906 0 0.806 0.481 1.563 1.031 2.444l0.194 0.313c0.5 0.744 1.1 2.006 1.1 3.719 0 0.825-0.288 1.75-0.65 2.919-0.125 0.413-0.262 0.856-0.4 1.337l-1.294 4.275c-0.050 0.181-0.212 0.3-0.4 0.3v0 0zM18.619 10.306l3.7 12 0.894-2.95c0.137-0.481 0.275-0.931 0.406-1.35 0.344-1.1 0.613-1.975 0.613-2.669 0-1.5-0.525-2.6-0.962-3.262l-0.2-0.319c-0.6-0.944-1.163-1.838-1.163-2.894 0-1.069 0.681-2.2 1.769-2.6-2.25-1.75-4.894-2.669-7.688-2.669-3.838 0-7.525 1.837-9.8 4.85 1.269 0 3.281-0.125 3.3-0.131 0 0 0 0 0 0 0.637 0 1 0.519 1 1.019s-0.356 0.863-0.844 0.863c0.019 0-0.331 0.069-0.831 0.106l4.075 11.381 2.387-6.344-1.794-5.019c-0.563-0.031-1.056-0.125-1.075-0.131-0.444 0.006-0.813-0.381-0.813-0.894 0-0.25 0.094-0.488 0.262-0.669 0.188-0.2 0.456-0.306 0.756-0.306 0.050 0 2.1 0.131 3.362 0.131 1.269 0 3.319-0.125 3.337-0.131 0 0 0 0 0 0 0.637 0 1 0.519 1 1.019s-0.356 0.863-0.844 0.863c0.031 0-0.331 0.069-0.85 0.106z"></path>
                              <path id="svg-ico" fill="#464646" d="M16.825 29.225c-1.481 0-2.637-0.169-3.756-0.538-0.106-0.038-0.194-0.113-0.244-0.212s-0.056-0.219-0.019-0.325l3.881-11.137c0.056-0.169 0.256-0.269 0.4-0.281 0.181 0 0.337 0.113 0.4 0.281l3.913 10.719c0.1 0.1 0.144 0.244 0.119 0.381-0.031 0.137-0.125 0.256-0.256 0.306-1.294 0.512-2.906 0.806-4.438 0.806zM13.744 28.012c0.906 0.256 1.875 0.369 3.081 0.369 1.25 0 2.556-0.206 3.656-0.581l-3.394-9.387-3.344 9.6z"></path>
                              <path id="svg-ico" fill="#464646" d="M22.45 27.413c-0.094 0-0.194-0.031-0.269-0.094-0.137-0.113-0.188-0.3-0.131-0.462l3.887-11.262c0.694-1.625 1.012-3.012 1.012-4.394 0-0.175-0.031-0.381-0.063-0.588-0.038-0.25-0.069-0.494-0.069-0.706 0-0.194 0.137-0.369 0.325-0.412 0.194-0.044 0.387 0.044 0.475 0.225 1.063 2.119 1.6 4.231 1.6 6.275 0 4.644-2.512 9-6.55 11.369-0.069 0.031-0.144 0.050-0.219 0.050zM27.744 12.213c-0.119 1.169-0.45 2.362-1.019 3.681l-3.469 10.063c3.181-2.313 5.119-6.031 5.119-9.975 0-1.225-0.212-2.487-0.631-3.769z"></path>
                              <path fill="#464646" d="M15.981 31.813c-8.725 0-15.825-7.1-15.825-15.825s7.1-15.825 15.825-15.825 15.825 7.1 15.825 15.825c0 8.581-7.25 15.825-15.825 15.825zM15.981 1.006c-8.262 0-14.981 6.719-14.981 14.981s6.719 14.981 14.981 14.981c8.119 0 14.981-6.863 14.981-14.981 0-8.262-6.725-14.981-14.981-14.981z"></path>
                            </svg>
                          </Ico>
                        </Img>
                        <Inform>
                          <ServiceHeading>
                            <ServiceHeadinga to="/diseno-web#wordpress">
                              Diseño Web personalizado
                            </ServiceHeadinga>
                          </ServiceHeading>
                          <ServiceText>Diseño Web 100% personalizado y a la medida con código fuente desde 0.</ServiceText>
                        </Inform>
                      </HelpContainer>
                    </AnimationContainer>
                  </Col>
                </ServiceRow>
              </ServiceWrap>
            </Container>
          </Section>
        )
    }

}

export default BotonApp